module.exports = __webpack_public_path__ + "img/ANTENNA TWIRL PURPLE.0f4346e.svg";